export default "__VITE_ASSET__Dppv2_ZC__"